import React from 'react';
import { useTranslation } from 'react-i18next';
import { IColumn } from '@kaleyra/emmy/dist/molecules/styledTable';
import { Instances } from '../../../../../constants';
import { DefaultPropertyType, AssetType, IAssets, AssetTypeWhatsapp } from '../../../../../interface';

import SeeMoreModal, {
	BaseSeeMorePropsType,
} from '../../../templates/SeeMoreModal';
import TableFactory from '../../../templates/TableTemplate';
import TitleSearchTable from '../../../templates/TitleSearchTable';

import {
	SmsId,
	SmsTemplate,
	DidNumber,
	WhatsappNumber,
	WhatsappTemplate,
	// KycDocuments,
} from './columnMap';
import Header from './Header';

import Styles from './index.module.scss';
import { debounce } from 'lodash';
import { CallbackType } from '../../../../../constants';
import { checkEnabledChannel } from '../../../../../utils';

export type MapStateToPropsType = {
	filters: Record<string, any>;
	data: IAssets[];
};

export type DispatchPropsType = {
	onTabChange: (currentTab: string) => void;
	onSearchChange: (searchStr?: string) => void;
};

type PropsType = BaseSeeMorePropsType & DispatchPropsType & MapStateToPropsType;

const AssetsTable = TableFactory(Instances.assetsDetailed);

const AssetsSeeMore: React.FC<PropsType> = ({
	onTabChange,
	onSearchChange,
	filters,
	data,
	...props
}) => {
	const { t } = useTranslation();

	const getColumn = (currentTab: string): IColumn[] => {
		switch (currentTab as AssetType | AssetTypeWhatsapp) {
			case AssetType.SenderId: {
				return SmsId();
			}
			case AssetType.SmsTemplate: {
				return SmsTemplate();
			}
			case AssetType.DidNumbers: {
				return DidNumber();
			}
			case AssetTypeWhatsapp.WaNumbers: {
				return WhatsappNumber();
			}
			case AssetTypeWhatsapp.WhatsappTemplate: {
				return WhatsappTemplate();
			}
			// case AssetType.KycDocs: {
			// 	return KycDocuments();
			// }
			default:
				return SmsId();
		}
	};

	const debouncedChange = React.useCallback<CallbackType>(
		debounce((value:any = "") => onSearch(value), 400),
		[]
	);

	const onSearch = (searchStr = '') => {
		onSearchChange(searchStr);
	};

	const getBody = (currentTab: string): React.ReactNode => {
		return (
			<>
				<div className={Styles.tableContainer}>
					<TitleSearchTable
						title={`${t(
							`assetsWidgetHeader${[
								Object.keys(AssetType).find(
									(key) =>
										(AssetType as any)[key] === currentTab
								) || Object.keys(AssetTypeWhatsapp).find(
									(key) =>
										(AssetTypeWhatsapp as any)[key] === currentTab
								),
							]}`
						)}`}
						onChange={debouncedChange}
						currentTab={currentTab}

					>
						<AssetsTable
							columns={getColumn(currentTab)}
							filters={{ asset: currentTab }}
						/>
					</TitleSearchTable>
				</div>
			</>
		);
	};

	const getTabs = () => {
		let tabs: DefaultPropertyType[] = [];
		Object.keys(AssetType).forEach((item: any) => {
			tabs.push({
				label:
					item === AssetType.SenderId
						? t(`assetsWidget${item}`)
						: t(`assetsWidgetHeader${item}`),
				value: (AssetType as any)[item],
			});
		});

		if (data[0].channel_status.whatsapp) {
			Object.keys(AssetTypeWhatsapp).forEach((item: any) => {
				tabs.push({
					label: t(`assetsWidgetHeader${item}`),
					value: (AssetTypeWhatsapp as any)[item],
				});
			});
		}
		if(!checkEnabledChannel(['sms']))  return tabs.slice(2,4);

		return tabs;
	};

	return (
		<SeeMoreModal
			header={
				<Header
					filters={filters}
					message={`${t(
						`assets${Object.keys(AssetType).find(
							(key) =>
								(AssetType as any)[key] === filters?.asset
						) || ''
						}ReportDownload`
					)}`}
				/>
			}
			getBody={(currentTab) => getBody(currentTab)}
			tabs={getTabs()}
			onTabClick={onTabChange}
			{...props}
		/>
	);
};

export default AssetsSeeMore;
